import { useCallback } from "react";
import { logCustomMessage } from "../../util/logger";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { getEmployeesLiteList } from "../../api/Employees";
import { useUserStore } from "../../store/user";

export default function useGetEmployeesLiteList() {
  const setEmployees = useUserStore((state) => state.setEmployees);

  const getLiteListOfEmployees = useCallback(async () => {
    const data = {
      PropertyList: ["EmployeeName", "EmployeeId"],
      Filter: "",
    };
    const response = await getEmployeesLiteList(data);

    logCustomMessage(
      "Get all employee IDs",
      SeverityLevel.Information,
      "Employees/GetLiteList",
      data,
      response
    );
    setEmployees(response.data);
    return response;
  }, [setEmployees]);

  return { getLiteListOfEmployees };
}
